import React, { useEffect, useState } from 'react';
import api from '../services/api';

export default function WACloudTemplates() {
  const [loading, setLoading] = useState(true);
  const [templates, setTemplates] = useState([]);
  const [msg, setMsg] = useState('');
  const [to, setTo] = useState('');
  const [tpl, setTpl] = useState('');
  const [lang, setLang] = useState('es');
  const [vars, setVars] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const r = await api.waCloud.listTemplates();
        if (mounted) setTemplates(r?.items || []);
      } catch (e) {
        if (mounted) setMsg(`Error: ${e.message}`);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const enviarPrueba = async () => {
    try {
      setMsg('');
      const variables = vars.trim() ? vars.split(',').map(s => s.trim()) : [];
      const r = await api.waCloud.sendTemplate({ to, templateName: tpl, language: lang, variables });
      setMsg(r?.ok ? 'Plantilla enviada (mock)' : 'No se pudo enviar');
    } catch (e) {
      setMsg(`Error: ${e.message}`);
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>WA Cloud: Plantillas</h2>
      <div style={{ marginBottom: 12 }}>
        <a href="/connect/whatsapp-cloud">← Volver al Wizard</a>
      </div>

      {loading && <div>Cargando…</div>}

      {!loading && (
        <div style={{ display: 'grid', gap: 16 }}>
          <div style={{ border: '1px dashed #ccc', borderRadius: 8, padding: 12 }}>
            <strong>Enviar prueba (mock)</strong>
            <div style={{ marginTop: 8, display: 'grid', gap: 8, maxWidth: 520 }}>
              <label>To (tel):
                <input style={{ width: '100%' }} value={to} onChange={e => setTo(e.target.value)} />
              </label>
              <label>Template:
                <input style={{ width: '100%' }} value={tpl} onChange={e => setTpl(e.target.value)} placeholder="mi_template" />
              </label>
              <label>Language:
                <input style={{ width: '100%' }} value={lang} onChange={e => setLang(e.target.value)} />
              </label>
              <label>Variables (coma-separadas):
                <input style={{ width: '100%' }} value={vars} onChange={e => setVars(e.target.value)} placeholder="Juan, 10:00 AM" />
              </label>
              <button onClick={enviarPrueba}>Enviar plantilla (mock)</button>
            </div>
          </div>

          <div style={{ border: '1px dashed #ccc', borderRadius: 8, padding: 12 }}>
            <strong>Listado de plantillas</strong>
            {templates.length === 0 ? (
              <div style={{ marginTop: 8 }}>Sin plantillas (mock).</div>
            ) : (
              <ul style={{ marginTop: 8 }}>
                {templates.map(t => (
                  <li key={t.name}>
                    {t.name} — {t.language} — {t.status}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}

      {msg && <div style={{ marginTop: 12, padding: 8, border: '1px solid #eee' }}>{msg}</div>}
    </div>
  );
}